// @flow
import * as React from 'react';
import {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {RequestApprovalPopup} from "borispage/admintab/doctab/AdminNewDocumentPopupPage";
import {SsqImages} from "images/SsqImages";
import {InputWrapForSelect} from "style/CommonStyledComponents";
import {Overlay} from "borispage/common/AdminCommonComponents";
import {useLoginInfo} from "hooks/useLoginInfo";
import {i18ntrans} from "language/i18nkey";
import {useApiAdminUsers} from "docwrite/community/popup/useApiAdminUsers";
import {ICreateLogItem, ICreateUserAlarmRequest, ISsqDataDocumentAdminPopup} from "repositories/SsqDataRepository";
import svcs from "services";
import {ADMISSION_TYPE, AdmissionType} from "definitions/AdmissionType";
import {IDocumentApprovalReqEmailRequest} from "repositories/NotificationService";
import {langutil} from "language/langutil";
import HttpStatus from "definitions/HttpStatus";
import {docutil} from "util/docutil";
import {ActionType} from "definitions/ActionType";
import {MenuType} from "definitions/MenuType";


interface Props {
};
export const ReqDelPopupWrap = forwardRef<{ show: ({doc: ISsqDataDocumentAdminPopup}) => Promise<any> }, Props>((props, ref) => {
  const loginInfo = useLoginInfo();
  const trans = i18ntrans.adminstrict;
  const [validation, setValidation] = useState({isEmptyApprUserEmail: false, isEmptyApprMessage: false});
  const [show, setShow] = useState<boolean>(false);
  const promise = useRef<{ resolve: any; reject: any }>({resolve: null, reject: null});
  const [apprUserEmail, setApprUserEmail] = useState('');
  const [apprMessage, setApprMessage] = useState('');
  const [doc, setDoc] = useState<ISsqDataDocumentAdminPopup>();
  const admins = useApiAdminUsers(doc?.exposeSiteLanguage, loginInfo?.department, show);

  const reqAdmissionDelReq = async (id: number, admission: ADMISSION_TYPE) => {
    await svcs.repoSsqData.putTechDocumentAdmission([id], admission);
  };

  const reqAlaramCreate = async (admission: ADMISSION_TYPE) => {
    const req: ICreateUserAlarmRequest = {
      admission,
      documentId: doc.id,
      docTitle: doc.docTitle,
      docType: doc.docType,
      parentDocumentId: undefined,
      userId: apprUserEmail,
      updateTime: new Date()
    };
    await svcs.repoSsqData.postGuestUserAlarm(req);
  };

  const reqDelReqLogCreate = async () => {
    const postLogItem: ICreateLogItem = {
      userId: "Set In BFF",
      userName: "Set In BFF",
      nickName: "Set In BFF",
      menuType: docutil.isTechDoc(doc.docType) ? MenuType.TECH_DOCUMENT : MenuType.DOCUMENT,
      actionType: ActionType.DEL_REQUEST,
      logContent: JSON.stringify({"documentId": doc.id}),
      updateTime: new Date()
    };
    await svcs.repoSsqData.postLogItem(postLogItem);
  };

  const reqSendEmail = async () => {
    // 삭제요청 이메일 전송.
    const emailReq: IDocumentApprovalReqEmailRequest = {
      type: 'DEL',
      approvalUserEmail: apprUserEmail,
      docTitle: doc.docTitle,
      docType: doc.docType,
      approvalMessage: apprMessage,
      modifierName: loginInfo.name,
      modifierNickName: loginInfo.nickname,
      modifierEmail: loginInfo.email,
      documentUrl: langutil.urlPrefix(doc.exposeSiteLanguage) + `/community/approval/${doc.id}`,
      lang: doc.exposeSiteLanguage,
    };

    console.log("doc appr req email req ", emailReq);
    await svcs.svcNotification.postGuestSendDocApprovalReqEmail(emailReq);
  };

  const saveHistory = async (docId: number) => {
    const nickname = loginInfo.nickname;
    const histreq = {
      comment: apprMessage,
      documentId: docId,
      admissionType: AdmissionType.DEL_REQUESTED,
      nickname: nickname
    };
    const historyStatus = await svcs.repoSsqData.postGeustDocHistory(histreq);

    if (historyStatus !== HttpStatus.NO_CONTENT) {
      alert(trans('I18N_DOCWRITE_HIST_INS_ERROR') + " Status " + historyStatus);
    }
  };
  const isValid = (): boolean => {
    // if (!apprMessage) setValidation((s) => ({...s, isEmptyApprMessage: true}));
    // if (!apprUserEmail) setValidation((s) => ({...s, isEmptyApprUserEmail: true}));
    const isEmptyApprMessage = apprMessage ? false : true;
    const isEmptyApprUserEmail = apprUserEmail ? false : true;
    setValidation({isEmptyApprUserEmail, isEmptyApprMessage});
    if (isEmptyApprMessage || isEmptyApprUserEmail) return false;
    return true;
  };

  useImperativeHandle(ref, () => ({
    show: ({doc}) => {
      return new Promise((resolve, reject) => {
        promise.current = {resolve, reject};
        setDoc(doc);
        setShow(true);
      });
    }
  }));

  const handleOk = async () => {
    if (!isValid()) return;
    await reqAdmissionDelReq(doc.id, 'DEL_REQUESTED');
    await saveHistory(doc.id);

    !["", null].includes(apprUserEmail) && await reqAlaramCreate('DEL_REQUESTED');
    await reqDelReqLogCreate();
    await reqSendEmail();

    setShow(false);
    promise.current.resolve({cmd: 'ok'});
  };


  return (
    <>{show &&
      <> <RequestApprovalPopup>
        <div className={"popup-top"}>
          <h2>{trans('I18N_DEL_APPR_REQ_TIT')}</h2>
          <button onClick={() => {
            //onChildCmd('setstate', {apprMessage: "", apprUserEmail: "", showReqApprPopup: false});
            promise.current.reject({cmd: 'close'});
            setShow(false);
          }}><img alt={"close_small_icon.svg"} src={SsqImages.common.icon.closeSmallIcon()}/></button>
        </div>
        <div className={"popup-content"}>
          <p>{trans('I18N_REQUEST_DESC')}</p>
          <div>
            <div className={"sub_tit"}>{trans('I18N_REQUEST_TO')}</div>
            <div className={'input_wrap'}>
              <InputWrapForSelect>
                <select defaultValue={undefined}
                  onChange={(e) => {
                    setValidation({...validation, isEmptyApprUserEmail: false});
                    setApprUserEmail(e.target.value || '');
                  }}
                  className={validation.isEmptyApprUserEmail ? "input-error" : ""}
                >
                  <option value={''}>{trans('I18N_REQUEST_TO_SELECT')}</option>
                  {admins.map((user, index) => {
                    return <option key={index} value={user.email}>
                      {user.name}/{user.department}
                    </option>;
                  })}
                </select>
                {validation.isEmptyApprUserEmail &&
                  <span className={"input-error-text"}>{trans('I18N_REQUEST_TO_ERROR')}</span>}
              </InputWrapForSelect>
            </div>
          </div>
          <div>
            <div className={"sub_tit"}>{trans('I18N_REQUEST_COMMENT')}</div>
            <div className={'input_wrap'}>
            <textarea maxLength={200}
              placeholder={trans('I18N_REQUEST_PLACEHOLDER')}
              className={validation.isEmptyApprMessage ? "input-error" : ""}
              onChange={(e) => {
                setValidation({...validation, isEmptyApprMessage: false});
                setApprMessage(e.target.value || '');
              }}/>
              {validation.isEmptyApprMessage &&
                <span className={"input-error-text"}>{trans('I18N_REQUEST_COMMENT_ERROR')}</span>}
            </div>
          </div>
        </div>
        <div className={"popup-bt"}>
          <button className={"batch-button delete-button"} onClick={() => {
            setShow(false);
            promise.current.reject({cmd: 'cancel'});
          }}>
            {trans('I18N_BUTTON_CANCEL')}
          </button>
          <button className={"post-button"}
            onClick={async () => await handleOk()}>{trans('I18N_BUTTON_APPR_REQUEST')}
          </button>
        </div>
      </RequestApprovalPopup>
        <Overlay/>
      </>}
    </>
  );
});

ReqDelPopupWrap.displayName = "ReqDelPopupWrap";